import React from 'react';
import './SpeakerBubble.css';

const SpeakerBubble = ({ imageUrl, index, onClick  }) => {
    const handleClick = () => {
        // Call the onClick function and pass the index
        onClick(index);
      };
    return (
        <div className="circular-image" onClick={handleClick}>
          <div className="image-container">
            <img  className="circle-image" src={imageUrl} alt="Circularbubble" />
          </div>
        </div>
      );
    };

export default SpeakerBubble;
